import { useEffect } from 'react';

type UseScrollLock = { isOpen: boolean };

export const useScrollLock = ({ isOpen }: UseScrollLock) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else document.body.style.overflow = 'auto';

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isOpen]);
};
